import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getFontSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useInputWrapperContext } from "./auth-service-tools304.js";
import classes from "./auth-service-tools306.js";
const defaultProps = {
  labelElement: "label"
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    label: {
      "--input-label-size": getFontSize(size),
      "--input-asterisk-color": void 0
    }
  };
});
const InputLabel = factory((_props, ref) => {
  const props = useProps("InputLabel", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    labelElement,
    size,
    required,
    htmlFor,
    onMouseDown,
    children,
    __staticSelector,
    variant,
    mod,
    ...others
  } = useProps("InputLabel", defaultProps, props);

  const _getStyles = useStyles({
    name: ["InputWrapper", __staticSelector],
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    rootSelector: "label",
    vars,
    varsResolver
  });

  const ctx = useInputWrapperContext();
  const getStyles = (ctx == null ? void 0 : ctx.getStyles) || _getStyles;
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...getStyles("label", (ctx == null ? void 0 : ctx.getStyles) ? {
      className,
      style
    } : void 0),
    component: labelElement,
    variant,
    size,
    ref,
    htmlFor: labelElement === "label" ? htmlFor : void 0,
    mod: [{
      required
    }, mod],
    onMouseDown: event => {
      onMouseDown == null ? void 0 : onMouseDown(event);

      if (!event.defaultPrevented && event.detail > 1) {
        event.preventDefault();
      }
    },
    ...others,
    children: [children, required && /* @__PURE__ */jsxRuntimeExports.jsx("span", { ...getStyles("required"),
      "aria-hidden": true,
      children: " *"
    })]
  });
});
InputLabel.classes = classes;
InputLabel.displayName = "@mantine/core/InputLabel";
export { InputLabel };